import _ from "lodash";
import React, { useRef } from "react";
import classes from "./UnitSelectionFeed.scss";
import UnitCard from "AppComponents/Cards/UnitCard";
import I18nHOC from "UIComponents/I18nHOC";
import { goToRelativeRoute } from "modules/Services";
import { connect } from "react-redux";
import { compose } from "lib/apolloClient";
import ConditionalWrapper from "Utils/ConditionalWrapper";
import { navigateGridWithArrowKeys } from "Utils";
import { EmptyState } from "@toddle-edu/ds-web";
import {
  NoDataIllustration,
  NoSearchInFilterIllustration,
} from "@toddle-edu/ds-theme";

const UnitSelectionFeed = ({
  items,
  updateSelectedItems,
  t,
  testId,
  parentType,
  selectedItems,
  isMultiSelect,
  cardDimensions,
  styles,
  disabledItems,
  showEmptyState,
  selectedGrade,
  selectedCourseId,
  goToRelativeRoute,
  isSearchEnabled,
  searchText,
  cardTheme,
  showGrades,
  showSubTitleTooltip,
  cardWrapperElement,
  newUnits,
  enableRouting,
  customCardComponent,
}) => {
  const unitCardRefs = useRef({});
  const containerRef = useRef(null);

  const checkIsDisabled = ({ id }) => {
    return _.findIndex(disabledItems, item => item == id) > -1;
  };

  const itemsLength = items.length;

  let containerComputedStyle;
  if (containerRef.current) {
    containerComputedStyle = window.getComputedStyle(containerRef.current);
  }

  const columnsCount = containerComputedStyle?.gridTemplateColumns?.split(" ")
    ?.length; // Calculate the number of cards per row

  const getUnitCardId = index => items[index]?.id;

  // Function to move focus based on key press
  const moveFocusToNextOrPrevFeedData = (event, index) => {
    navigateGridWithArrowKeys({
      event,
      index,
      columnsCount,
      itemsCount: itemsLength,
      refList: unitCardRefs,
      getItemId: getUnitCardId,
    });
  };

  return (
    <div
      className={classes.container}
      style={_.get(styles, "feedParentContainer", {})}
    >
      <div
        className={classes.itemFeedContainer}
        style={styles.itemFeedContainer}
        ref={containerRef}
      >
        {_.map(items, (item, index) => {
          let detailsString = "";
          if (parentType == "SCHEDULER") {
            detailsString = t("common:weekCount_interval", {
              postProcess: "interval",
              count: _.get(item.duration, `week`, 0),
            });
          } else if (parentType == "ASSESSMENT_EVALUTATION") {
            detailsString = t("common:le_with_count", {
              count: _.get(item, `assessmentCount`, 0),
            });
          }
          let isSelected = false;
          if (isMultiSelect) {
            isSelected = _.includes(selectedItems, item.id);
          } else {
            isSelected = selectedItems == item.id;
          }
          const isDisabled = checkIsDisabled({ id: item.id });

          const isNewUnit = _.includes(newUnits, item.id);

          return customCardComponent ? (
            React.cloneElement(customCardComponent, {
              data: item,
              onClickSelection: updateSelectedItems,
              isSelected,
              isDisabled,
              id: item.id,
              testId: testId ? `${testId}-item` : undefined,
            })
          ) : (
            <div className={classes.cardContainer} key={item.id}>
              <ConditionalWrapper
                type="wrapperAsElement"
                wrapper={cardWrapperElement}
                condition={!!cardWrapperElement}
                data={item}
                isSelected={isSelected}
                onCardClick={updateSelectedItems}
                isNew={isNewUnit}
              >
                <UnitCard
                  cardDimensions={cardDimensions}
                  item={item}
                  testId={testId}
                  onItemClick={updateSelectedItems}
                  detailsString={detailsString}
                  isSelected={isSelected}
                  isDisabled={isDisabled}
                  theme={cardTheme}
                  showGrades={showGrades}
                  showSubTitleTooltip={showSubTitleTooltip}
                  hideDefaultActions={!!cardWrapperElement}
                  t={t}
                  index={index}
                  unitCardRefs={unitCardRefs}
                  onKeyDown={e => moveFocusToNextOrPrevFeedData(e, index)} // for keyboard accessibility
                />
              </ConditionalWrapper>
            </div>
          );
        })}
        {!itemsLength && showEmptyState ? (
          <div className={classes.emptyStateContainer}>
            {isSearchEnabled && searchText ? (
              <EmptyState
                illustration={NoSearchInFilterIllustration}
                title={t("common:no_label_found", {
                  label:
                    isSearchEnabled && searchText
                      ? t("common:result_plural")
                      : t("common:unit_plural").toLowerCase(),
                })}
                subtitle={
                  isSearchEnabled && searchText
                    ? t("calendar:no_unit_found_in_search", {
                        searchText,
                      })
                    : t("calendar:no_unit_found_in_grade", {
                        grade: selectedGrade,
                      })
                }
              />
            ) : (
              <EmptyState
                illustration={NoDataIllustration}
                title={t("unitPlan:no_unit_created_in_grade")}
              />
            )}
            {enableRouting ? (
              <div className={classes.emptyStateSubTextContainer}>
                <div className={classes.emptyStateSubTextDesc}>
                  {isSearchEnabled && searchText ? null : (
                    <div
                      className={classes.emptyStateSubTextLink}
                      onClick={() => {
                        goToRelativeRoute({
                          route: `../${selectedCourseId}/unitPlans`,
                        });
                      }}
                    >
                      {t("unitPlan:units_of_inquiry")}
                    </div>
                  )}
                </div>
              </div>
            ) : null}
          </div>
        ) : null}
      </div>
    </div>
  );
};

const mapStateToProps = () => ({});

const mapActionCreators = {
  goToRelativeRoute,
};

export default compose(
  connect(mapStateToProps, mapActionCreators),
  I18nHOC({ resource: ["common", "unitPlan"] })
)(UnitSelectionFeed);

UnitSelectionFeed.defaultProps = {
  isSearchEnabled: false,
  showEmptyState: false,
  enableRouting: true,
  cardTheme: {},
  newUnits: [],
};
